export default "__VITE_ASSET__Bkms$TI6__"